import { useProject } from 'hooks/useProject'
import { useProjectsForCompany } from 'hooks/useProjectsForCompany'
import React, { FC } from 'react'
import { NavDropdown } from 'react-bootstrap'
import { CompanyIdUrlParam, ProjectIdUrlParam, TemplateIdUrlParam } from 'types'
import { useAppContext } from 'state/context'
import { duplicateTemplate } from 'state/async_actions'

export const DefaultDropdownText = 'Duplicate Template to Project'
export type DuplicateTemplateParams = CompanyIdUrlParam &
  ProjectIdUrlParam &
  TemplateIdUrlParam

export const DuplicateTemplateSelector: FC<DuplicateTemplateParams> = ({
  companyId,
  projectId,
  templateDocumentId,
}) => {
  const activeProject = useProject(projectId)
  const activeCompanyProjects = useProjectsForCompany(companyId)
  const [, dispatch] = useAppContext()

  return (
    <NavDropdown
      title={DefaultDropdownText}
      id="project-nav-dropdown"
      className="duplicate-project">
      {activeCompanyProjects
        .filter((project: any) => project?.status != "inactive" && (activeProject ? activeProject.id !== project.id : true))
        .map(project => {
          const onSelect = () =>
            duplicateTemplate(dispatch, project.id, templateDocumentId);
          return (
            <NavDropdown.Item key={project.id} onSelect={onSelect}>
              {project.name}
            </NavDropdown.Item>
          )
        })}
    </NavDropdown>
  )
}
